import { template as template_9f24e62c88794bdb84a2070205e199b3 } from "@ember/template-compiler";
import { t } from 'ember-intl';
import { inputVal } from 'eflex/helpers';
import { on } from '@ember/modifier';
import CheckboxInput from 'eflex/components/checkbox-input';
export default template_9f24e62c88794bdb84a2070205e199b3(`
<div class="dynamic-object-config-wrapper" ...attributes>
  <div class="property-row mb-2">
    <label class="form-label">
      {{t "name"}}
    </label>
    <input
      type="text"
      value={{@dynamicObjectName}}
      disabled={{@disabled}}
      class="dynamic-object-name-input form-control"
      {{on "input" (inputVal @updateObjectName)}}
    />
  </div>
  <div class="property-row">
    <CheckboxInput
      class="dynamic-object-show"
      @disabled={{@disabled}}
      @checked={{@startHidden}}
      @label={{t "workInstructions.startHidden"}}
      @onChange={{@updateStartHidden}}
    />
  </div>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
